import { render, staticRenderFns } from "./STOPage.vue?vue&type=template&id=4309180d&scoped=true"
import script from "./STOPage.vue?vue&type=script&lang=js"
export * from "./STOPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309180d",
  null
  
)

export default component.exports